module.exports = __webpack_public_path__ + "static/elizabeth-red-e258948b9ee109aba0e3d95d776efb39.jpg";